import { get } from 'lodash'
import bus from '@/utils/eventBus'

export default function () {
  this.rule.agenda_id = get(this.$route, 'query.agenda_id', null)
  this.existsRegister('/v1/professional/agendas/agendas', (data, meta) => {
    this.optionsAgendas = data
  })

  // evento de cancelamento pelo preview
  bus.$on('cancel-on-preview', values => {
    this.cancelOnPreview = values.show
    // removendo class para ativar biotão pra previzualiação
    this.publishing = false
    this.rule.schedulings = []
  })

  bus.$on('publishing-on-preview', values => {
    this.publishing = values.show
  })

  bus.$on('published-on-preview', values => {
    this.publishedOnPreview = values.show
    this.rule.schedulings = []
  })
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/rules/form/resources/mounted.js